import { useState } from "react";

// Paginação client-side simples pra listas que carregam todos os itens.
// Uso: const pg = usePagedList(filteredItems); -> renderiza pg.pageItems e
// passa o resto pro <PaginationBar/>.
export default function usePagedList(items, defaultSize = 25) {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(defaultSize);

  const list = Array.isArray(items) ? items : [];
  const total = list.length;
  const maxPage = Math.max(0, Math.ceil(total / pageSize) - 1);
  const safePage = Math.min(page, maxPage); // auto-clamp quando o filtro reduz a lista
  const pageItems = list.slice(safePage * pageSize, safePage * pageSize + pageSize);

  const onPageSizeChange = (size) => {
    setPageSize(size);
    setPage(0);
  };

  return {
    page: safePage,
    pageSize,
    total,
    pageItems,
    onPageChange: setPage,
    onPageSizeChange,
  };
}
